import { Iterable, IAddable, ObjUtils } from "./ObjUtils";

export class List<T> implements Iterable<T>, IAddable<T> {
	public Values: Array<T>;

	constructor(array?: Array<T>) {
		if (array)
			this.Values = array;
		else
			this.Values = new Array<T>();
	}

	public Get(index:number): T {
		return this.Values[index];
	}

	public Set(index:number, val:T): T {
		return this.Values[index] = val;
	}

	public get Count(): number {
		return this.Values.length;
	}

	public Add(value: T):void {
		this.Values.push(value);
	}

	public AddAt(index: number, value: T): void {
		this.Values.splice(index, 0, value);
	}

	public AddRange(other: List<T>): void {
		other.ForEach((elem: T) => {
			this.Add(elem);
		}, this);
	}

	public Sort(compareFn?: (a: T, b: T) => number): void {
		if (compareFn)
			this.Values.sort(compareFn);
		else
			this.Values.sort(ObjUtils.CompareTo);
	}

	public Clear(): void {
		this.Values.length = 0;
	}

	public Contains(value: T): boolean {
		return this.Values.some((val) => {
			return ObjUtils.Equals(val, value);
		});
	}

	public Except(other: List<T>) {
		var result = new List<T>();

		this.ForEach((member) => {
			if (!other.Contains(member))
				result.Add(member);
		});

		return result;
	}

	public IndexOf(value: T):number {
		var index = -1;

		this.Values.some((val, i) => {
			if (ObjUtils.Equals(value, val)) {
				index = i;
				return true;
			}
		});

		return index;
	}

	public IndexOfPredicate(predicate: (value: T)=>boolean): number {
		var index = -1;

		this.Values.some((val, i) => {
			if (predicate(val)) {
				index = i;
				return true;
			}
		});

		return index;
	}

	public Remove(value: T): boolean {
		var index = this.IndexOf(value);
		return this.RemoveAt(index);
	}

	public RemoveAt(index: number): boolean {
		if (index >= 0) {
			this.Values.splice(index, 1);
			return true;
		}
		return false;
	}

	public UnionWith(other: Iterable<T>) {
		other.ForEach((val) => {
			this.Add(val);
		});
	}

	public ForEach(callbackfn:(value:T,index:number, array:T[]) => void, thisArg?:any):void {
		this.Values.forEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: T, index: number, array: T[]) => boolean, thisArg?: any):boolean {
		return this.Values.some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: T, index: number, array: T[]) => boolean, thisArg?: any): boolean {
		return this.Values.every(callbackfn, thisArg);
	}

	public ToArray(): T[] {
		let arr: T[] = [];
		this.ForEach((value: T) => {
			arr.push(value);
		});
		return arr;
	}

}
